import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSFaq,
  CMSGroupParams,
  CMSHowToParticipate,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';
import { useCommonStore } from '@/store';

export interface PageDescription extends CMSGroupParams {
  descriptionText: string;
}

export interface LockedCardDescription extends CMSGroupParams {
  cardDescription: string;
}

export interface ScratchGameApi extends CMSApiBase {
  pageTitle: string;
  pageDescription: PageDescription[];
  leftImg: CMSImageBase;
  rightImg: CMSImageBase;
  mobImg: CMSImageBase;
  leftDecorImg: CMSImageBase;
  rightDecorImg: CMSImageBase;
  promoCode: string;
  topBg: CMSImageBase;
  lockedCardTitle: string;
  lockedCardDescription: LockedCardDescription[];
  howToParticipateTitle: string;
  howToParticipate: CMSHowToParticipate[];
  faqTitle: string;
  faq: CMSFaq[];
  start: string;
  end: string;
  fivePlusDepCardTitle: string;
  fivePlusDepCardDescription: string;
}

export const scratchGameCMSV3 = (lang: string) =>
  request<ScratchGameApi>({
    url: buildCmsUrl({ path: 'scratch-game', lang }),
  });

export const scratchGameCMSV4 = (lang: string) =>
  request<ScratchGameApi>({
    url: buildCmsUrl({
      path: 'scratch-game',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<ScratchGameApi>
    ),
  });

export const scratchGameCMS = isCMSV3 ? scratchGameCMSV3 : scratchGameCMSV4;

export const fetchScratchGame = (lang: string) => {
  useCommonStore.setState({ pendingScratchGameData: true });

  return scratchGameCMS(lang)
    .then(({ data }) => {
      useCommonStore.setState({ scratchGameData: data });
    })
    .finally(() => {
      useCommonStore.setState({ pendingScratchGameData: false });
    });
};
